/**
 * コレクションページのページネーション遷移時に、
 * 商品一覧の先頭位置へスクロールを戻すための補助スクリプト。
 *
 * このストアでは Boost AI Search & Filter により、
 * ページネーション時に full reload ではなく same-document 遷移で
 * 商品一覧とページネーションが差し替えられる。
 *
 * そのため、遷移前の scrollY が保持されたまま次ページへ移動し、
 * 商品数の少ない最終ページでは画面下部付近から表示されることがある。
 *
 * 本スクリプトでは、ページネーションクリック時に即スクロールは行わず、
 * 対象遷移を検知して scroll reset を予約し、DOM 更新完了後に
 * `.CollectionMain` の先頭まで 1 回だけスクロールする。
 *
 * 対象はコレクションページ内のページネーション遷移のみで、
 * 通常クリック以外や同一ページ遷移は除外している。
 */

(function () {
  if (!document.querySelector('.CollectionMain')) {
    return;
  }

  var pendingScrollReset = false;
  var scrollExecutionScheduled = false;
  var pendingResetTimeoutId = null;
  var PENDING_RESET_TIMEOUT_MS = 1500;

  function isPlainLeftClick(event, link) {
    if (event.defaultPrevented) {
      return false;
    }

    if (event.button !== 0) {
      return false;
    }

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return false;
    }

    if (link.target && link.target.toLowerCase() === '_blank') {
      return false;
    }

    return true;
  }

  function getPageNumber(url) {
    var rawPage = url.searchParams.get('page');
    var parsed = parseInt(rawPage, 10);

    if (Number.isNaN(parsed) || parsed < 1) {
      return 1;
    }

    return parsed;
  }

  function isPaginationPageNavigation(url) {
    if (url.origin !== window.location.origin) {
      return false;
    }

    if (url.pathname !== window.location.pathname) {
      return false;
    }

    if (!url.searchParams.has('page')) {
      return false;
    }

    var currentUrl = new URL(window.location.href);
    var currentPage = getPageNumber(currentUrl);
    var nextPage = getPageNumber(url);

    return currentPage !== nextPage;
  }

  function getHeaderHeight() {
    var rawValue = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var parsed = parseInt(rawValue, 10);

    if (Number.isNaN(parsed)) {
      return 0;
    }

    return parsed;
  }

  function scrollToCollectionTop() {
    var collectionMain = document.querySelector('.CollectionMain');

    if (!collectionMain) {
      return;
    }

    var headerHeight = getHeaderHeight();
    var absoluteTop = collectionMain.getBoundingClientRect().top + window.pageYOffset;
    var targetTop = Math.max(0, absoluteTop - headerHeight);

    window.scrollTo({
      top: targetTop,
      behavior: 'auto'
    });
  }

  function clearPendingState() {
    pendingScrollReset = false;
    scrollExecutionScheduled = false;

    if (pendingResetTimeoutId !== null) {
      clearTimeout(pendingResetTimeoutId);
      pendingResetTimeoutId = null;
    }
  }

  function armPendingFailSafeTimeout() {
    if (pendingResetTimeoutId !== null) {
      clearTimeout(pendingResetTimeoutId);
    }

    pendingResetTimeoutId = setTimeout(function () {
      clearPendingState();
    }, PENDING_RESET_TIMEOUT_MS);
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('.boost-pfs-filter-bottom-pagination a, .Pagination a');

      if (!link) {
        return;
      }

      if (!isPlainLeftClick(event, link)) {
        return;
      }

      var destination;

      try {
        destination = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (!isPaginationPageNavigation(destination)) {
        return;
      }

      pendingScrollReset = true;
      armPendingFailSafeTimeout();
    },
    true
  );

  function scheduleScrollResetAfterDomUpdate() {
    if (!pendingScrollReset || scrollExecutionScheduled) {
      return;
    }

    scrollExecutionScheduled = true;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollToCollectionTop();
        clearPendingState();
      });
    });
  }

  var observer = new MutationObserver(function () {
    scheduleScrollResetAfterDomUpdate();
  });

  observer.observe(document.querySelector('.CollectionMain'), {
    childList: true,
    subtree: true
  });
})();
